import script from "./BookingHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingHome.vue?vue&type=script&setup=true&lang=js"

import "./BookingHome.vue?vue&type=style&index=0&id=7fa91180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa91180"]])

export default __exports__